import type { FC } from 'react';
import { SkeletonParent } from '@/components/ui/Skeleton/skeleton';

export const ReviewSkeleton: FC = () => {
  return (
    <div className="flex gap-4 items-start">
      {/* Rating stars skeleton */}
      <SkeletonParent className="h-6 w-32 shrink-0" />
      <div className="flex-1">
        {/* Username skeleton */}
        <SkeletonParent className="h-5 w-24 mb-2" />
        {/* Comment skeleton lines */}
        <SkeletonParent className="h-4 w-full mb-1" />
        <SkeletonParent className="h-4 w-3/4 mb-3" />
        {/* Date skeleton */}
        <SkeletonParent className="h-3 w-20" />
      </div>
    </div>
  );
};
